<template>
  <div class="summary">

    <div class="summary-head">
      <h1 class="summary-name">{{ account.name }}</h1>
      <span class="badge" :class="statusBadgeClass">{{ statusLabel }}</span>

      <div v-if="tags.length" class="tags-cell">
        <span v-for="tag in tags" :key="tag.id" class="tag-badge"
              :style="{ backgroundColor: `#${tag.color}`, color: tagTextColor(tag.color) }">
          {{ tag.name }}
        </span>
      </div>
    </div>

    <div class="summary-facts">
      <div class="fact">
        <span class="fact-label">ID da conta</span>
        <span class="fact-value">{{ account.id }}</span>
      </div>

      <div class="fact">
        <span class="fact-label">White label</span>
        <span class="fact-value">{{ partner ? partner.name : 'Sem parceria' }}</span>
      </div>

      <div class="fact">
        <span class="fact-label">Produtos contratados</span>
        <span class="fact-value">{{ productsCount }}</span>
      </div>

      <div class="fact">
        <span class="fact-label">Produtos em teste</span>
        <span class="fact-value">{{ trialCount }}</span>
      </div>

      <div class="fact">
        <span class="fact-label">Vigência a partir de</span>
        <span class="fact-value">{{ contractStart }}</span>
      </div>

      <div v-if="deletionLabel" class="fact">
        <span class="fact-label">Exclusão da conta</span>
        <span class="fact-value deletion">{{ deletionLabel }}</span>
      </div>

      <div class="fact">
        <span class="fact-label">Criado em</span>
        <span class="fact-value">{{ createdAt }}</span>
      </div>

      <div class="fact">
        <span class="fact-label">Atualizado em</span>
        <span class="fact-value">{{ updatedAt }}</span>
      </div>
    </div>

  </div>
</template>

<script>
  import { accountStatusBadgeClass, translateAccountStatus } from '@/utils/accountStatus'
  import { tagTextColor } from '@/utils/accountTags'
  import { deletionLabelFor } from '@/models/accountRetention'

  export default {
    computed: {
      createdAt() {
        return this.formatDatetime(this.account.created_at)
      },
      statusBadgeClass() {
        return accountStatusBadgeClass(this.account.subscription_type)
      },
      statusLabel() {
        const label = translateAccountStatus(this.account.subscription_type)
        return label === '-' ? 'Sem status' : label
      },
      deletionLabel() {
        return deletionLabelFor(this.account.deletion_base_at)
      },
      contractStart() {
        const document = this.account.contract_document || {}
        return this.formatDate(document.start_date)
      },
      tags() {
        return this.account.tags || []
      },
      updatedAt() {
        return this.formatDatetime(this.account.updated_at)
      }
    },
    methods: {
      tagTextColor,
      formatDate(value) {
        return value ? this.$options.filters.date(value) : '-'
      },
      formatDatetime(value) {
        return value ? this.$options.filters.datetime(value) : '-'
      }
    },
    name: 'AccountSummary',
    props: {
      account: { required: true, type: Object },
      partner: { default: null, type: Object },
      productsCount: { default: 0, type: Number },
      trialCount: { default: 0, type: Number }
    }
  }
</script>

<style scoped>
  .summary {
    padding: 20px 24px;
    margin-bottom: 24px;
    border: 1px solid var(--border-color);
    border-radius: 5px;
    background: var(--card-bg);
  }

  .summary-head {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
  }

  .summary-name {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: var(--primary-text-color);
  }

  .badge {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    color: white;
    white-space: nowrap;
  }

  .badge-success { background-color: #28a745; }
  .badge-warning { background-color: #FFC866; color: #051B30; }
  .badge-danger { background-color: #dc3545; }
  .badge-info { background-color: #318BE3; }
  .badge-secondary { background-color: #6c757d; }

  .tags-cell {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
  }

  .tag-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    white-space: nowrap;
    line-height: 1.2;
  }

  .summary-facts {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 32px;
    margin-top: 20px;
  }

  .fact {
    display: flex;
    flex-direction: column;
  }

  .fact-label {
    font-size: 12px;
    color: var(--secondary-text-color);
  }

  .fact-value {
    font-size: 14px;
    font-weight: 600;
    color: var(--primary-text-color);
  }

  .deletion {
    color: #d9534f;
  }
</style>
